import remoteOralExamService from '../../../services/RemoteOralExamService';
import routeTypeService from '../../../services/RouteTypeService';
import { methods } from '../../../services/api/ApiConstants';
import RemoteOralExamConstants from '../../../../src/constants/RemoteOralExamConstants';

const zoomWrapperSelector = {
    selectFrameSrc(sessionInfo) {
        const credentials = remoteOralExamService.getZoomCredentials(sessionInfo) || {};
        const { meetingId, password, signature, token, type, sdkKey, sdkSignature } = credentials;
        const isZoomHuichangType = type === RemoteOralExamConstants.callTypes.zoom_huichang;
        const isZoomType = type === RemoteOralExamConstants.callTypes.zoom;
        const isZoomSdkType = type === RemoteOralExamConstants.callTypes.zoom_sdk_app;
        const { firstName, evaluatorFirstName } = sessionInfo;
        const userNameParam = firstName ? `&userName=${firstName}` : '';
        const candidateName = firstName ? `&candidateFirstName=${firstName}` : '';
        const evaluatorName = evaluatorFirstName ? `&evaluatorFirstName=${evaluatorFirstName}` : '';
        const typeParam = type ? `&type=${type}` : '';
        let tokenParam = '';
        let signatureParam = '';
        if (isZoomHuichangType || isZoomType) {
            tokenParam = token ? `&token=${token}` : '';
            signatureParam = signature ? `&signature=${signature}` : '';
        }
        if (isZoomSdkType) {
            tokenParam = sdkKey ? `&token=${sdkKey}` : '';
            signatureParam = sdkSignature ? `&signature=${sdkSignature}` : '';
        }

        return meetingId && password && `${methods.VCC}?meetingNumber=${meetingId}&password=${password}`
        + `${userNameParam}${signatureParam}${tokenParam}${candidateName}${evaluatorName}${typeParam}&isTT=true`;
    },

    mapStateToProps({ remoteOralExam: { sessionInfo }, currentlyShown: { routeType } }) {
        return {
            frameSrc: this.selectFrameSrc(sessionInfo),
            isMenuPage: routeTypeService.isMenuPage(routeType),
            isTopicVisible: remoteOralExamService.isDisplayStatusVisible(sessionInfo),
        };
    },
};

export default zoomWrapperSelector;
